import { IJWTUserPayload } from "../../../interfaces/JWTUserPayload";

export const USER_LOGIN_INFO_INDEX = "bx-user-login-provider";

export function detectUserSessionInformation(token?: IJWTUserPayload) {
  if (token && token.loggedWith) {
    const userLoggedWith = token.loggedWith.toString();
    localStorage.setItem(USER_LOGIN_INFO_INDEX, userLoggedWith);
  } else {
    localStorage.removeItem(USER_LOGIN_INFO_INDEX);
  }
}
